import { render, staticRenderFns } from "./bottomSection.vue?vue&type=template&id=cf749b9e&"
import script from "./bottomSection.vue?vue&type=script&lang=js&"
export * from "./bottomSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports